import Layout from "@/components/layout/Layout";
import PageHero from "@/components/shared/PageHero";
import SEOHead from "@/components/seo/SEOHead";
import SchemaMarkup from "@/components/seo/SchemaMarkup";
import { FileText, AlertTriangle, HeadphonesIcon } from "lucide-react";

const domainExtensions = [
  {
    extension: ".bd",
    documents: ["জাতীয় পরিচয়পত্র (NID)"],
    usage: "ব্যক্তিগত ওয়েবসাইট, যেকোনো ব্যক্তি বা প্রতিষ্ঠান",
  },
  {
    extension: ".com.bd",
    documents: [
      "যেকোন একটি বৈধ ডকুমেন্ট (ট্রেড লাইসেন্স / TIN / VAT / ইনকরপোরেশন সার্টিফিকেট / সরকারি সার্টিফিকেট)",
      "প্রতিষ্ঠানের মালিক বা প্রতিনিধির জাতীয় পরিচয়পত্র (NID)",
      "নাম না মিললে Authorization Letter",
    ],
    usage: "ব্যবসা প্রতিষ্ঠান, ব্র্যান্ড বা কোম্পানির অফিসিয়াল ওয়েবসাইট",
  },
  {
    extension: ".net.bd",
    documents: [
      "ট্রেড লাইসেন্স / TIN / VAT / ইনকরপোরেশন সার্টিফিকেট / সরকারি সার্টিফিকেট",
      "মালিক বা প্রতিনিধির জাতীয় পরিচয়পত্র (NID)",
      "নাম না মিললে Authorization Letter",
    ],
    usage: "IT কোম্পানি, ISP ও নেটওয়ার্ক সার্ভিস প্রোভাইডার",
  },
  {
    extension: ".org.bd",
    documents: [
      "NGO Affairs Bureau / Society Registration Certificate অথবা ট্রেড লাইসেন্স / TIN / VAT / ইনকরপোরেশন সার্টিফিকেট",
      "দায়িত্বপ্রাপ্ত ব্যক্তির জাতীয় পরিচয়পত্র (NID)",
      "নাম না মিললে Authorization Letter",
    ],
    usage: "NGO, অলাভজনক প্রতিষ্ঠান ও ফাউন্ডেশন",
  },
  {
    extension: ".edu.bd",
    documents: [
      "শিক্ষা মন্ত্রণালয় / বোর্ড / UGC অনুমোদনপত্র অথবা বৈধ ট্রেড লাইসেন্স / সরকারি সার্টিফিকেট",
      "দায়িত্বপ্রাপ্ত ব্যক্তির জাতীয় পরিচয়পত্র (NID)",
      "নাম না মিললে Authorization Letter",
    ],
    usage: "স্কুল, কলেজ, কোচিং, মাদ্রাসা, বিশ্ববিদ্যালয় ও শিক্ষা প্রতিষ্ঠান",
  },
  {
    extension: ".ac.bd",
    documents: [
      "সরকার বা UGC কর্তৃক Recognition ডকুমেন্ট (অবশ্যই প্রয়োজন)",
      "ট্রেড লাইসেন্স / TIN / VAT / ইনকরপোরেশন সার্টিফিকেট (যদি থাকে)",
      "দায়িত্বপ্রাপ্ত ব্যক্তির জাতীয় পরিচয়পত্র (NID)",
    ],
    usage: "একাডেমিক রিসার্চ প্রতিষ্ঠান, উচ্চশিক্ষা ও গবেষণা সংস্থা",
  },
  {
    extension: ".gov.bd",
    documents: [
      "সরকারি অফিসিয়াল অনুমোদনপত্র",
      "সংশ্লিষ্ট প্রতিষ্ঠানের লেটারহেডে আবেদন",
      "দায়িত্বপ্রাপ্ত কর্মকর্তার জাতীয় পরিচয়পত্র (NID)",
      "GO / Office Order কপি",
    ],
    usage: "সরকারি দপ্তর, মন্ত্রণালয় ও সরকারি প্রকল্প",
  },
  {
    extension: ".mil.bd",
    documents: [
      "প্রতিরক্ষা মন্ত্রণালয় বা সংশ্লিষ্ট বাহিনীর অনুমোদনপত্র",
      "দায়িত্বশীল কর্মকর্তার অফিসিয়াল আইডি",
    ],
    usage: "সেনাবাহিনী, নৌবাহিনী, বিমানবাহিনী, প্রতিরক্ষা সংক্রান্ত প্রতিষ্ঠান",
  },
  {
    extension: ".info.bd",
    documents: ["জাতীয় পরিচয়পত্র (NID)"],
    usage: "নিউজ পোর্টাল, ব্লগ ও তথ্যভিত্তিক ওয়েবসাইট",
  },
  {
    extension: ".id.bd",
    documents: ["জাতীয় পরিচয়পত্র (NID)"],
    usage: "পার্সোনাল আইডেন্টিটি ডোমেইন",
  },
  {
    extension: ".ai.bd",
    documents: ["জাতীয় পরিচয়পত্র (NID)"],
    usage: "AI প্রজেক্ট, ব্যক্তিগত বা টেক‑ভিত্তিক ব্যবহার",
  },
  {
    extension: ".বাংলা",
    documents: ["জাতীয় পরিচয়পত্র (NID)"],
    usage: "বাংলা স্ক্রিপ্ট ডোমেইন, বাংলা ভাষাভিত্তিক ওয়েবসাইট",
  },
  {
    extension: ".sch.bd",
    documents: [
      "শিক্ষা মন্ত্রণালয় / বোর্ড / UGC অনুমোদন অথবা ট্রেড লাইসেন্স / TIN / ইনকরপোরেশন সার্টিফিকেট",
      "দায়িত্বপ্রাপ্ত ব্যক্তির জাতীয় পরিচয়পত্র (NID)",
      "নাম না মিললে Authorization Letter",
    ],
    usage: "স্কুল, কোচিং সেন্টার ও মাদ্রাসা",
  },
  {
    extension: ".tv.bd",
    documents: [
      "ট্রেড লাইসেন্স / TIN / ইনকরপোরেশন সার্টিফিকেট",
      "প্রতিষ্ঠানের প্রতিনিধির জাতীয় পরিচয়পত্র (NID)",
      "নাম না মিললে Authorization Letter",
    ],
    usage: "টিভি চ্যানেল, ব্রডকাস্ট ও মিডিয়া সার্ভিস",
  },
];

const RequiredDocuments = () => {
  return (
    <Layout>
      <SEOHead
        title=".BD ডোমেইন রেজিস্ট্রেশনের প্রয়োজনীয় ডকুমেন্ট | Web Host Buy BD"
        description=".BD ডোমেইন রেজিস্ট্রেশনের জন্য প্রয়োজনীয় ডকুমেন্টের সম্পূর্ণ তালিকা। .com.bd, .edu.bd, .org.bd, .net.bd সহ সকল .BD এক্সটেনশনের ডকুমেন্ট গাইড। Domain registration Bangladesh by Web Host Buy BD."
        canonical="/required-documents"
        noindex={true}
        keywords="domain registration Bangladesh, cheap domain Bangladesh, Web Host Buy BD, bd domain registration"
      />
      <SchemaMarkup
        type="page"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Required Documents", url: "/required-documents" },
        ]}
        pageName=".BD Domain Registration Required Documents"
        pageDescription="Complete guide to required documents for .BD domain registration in Bangladesh"
      />
      <PageHero
        badge="ডকুমেন্টেশন গাইড"
        title="কোন .BD ডোমেইনের জন্য কোন ডকুমেন্ট দরকার?"
        subtitle="বাংলাদেশে .BD ডোমেইন রেজিস্ট্রেশনের জন্য প্রয়োজনীয় ডকুমেন্টের সম্পূর্ণ তালিকা।"
      />

      {/* Introduction */}
      <section className="py-16 bg-background">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="p-8 rounded-2xl bg-card border border-border mb-12">
              <p className="text-muted-foreground leading-relaxed mb-6">
                বাংলাদেশে .BD ডোমেইন রেজিস্ট্রেশন করার সময় কোন এক্সটেনশনের জন্য কোন ডকুমেন্ট লাগবে—এটা অনেকেই পরিষ্কারভাবে জানেন না। BTCL-এর অফিসিয়াল নীতিমালা অনুযায়ী প্রতিটি .BD এক্সটেনশনের জন্য ডকুমেন্টেশন আলাদা। ভুল বা অসম্পূর্ণ কাগজপত্র জমা দিলে আবেদন রিজেক্ট, ভেরিফিকেশন দেরি, এমনকি ডোমেইন সাসপেন্ড হওয়ার ঝুঁকি থাকে।
              </p>
              <p className="text-foreground font-medium mb-4">
                Web Host Buy BD–এর এই গাইডে আপনি এক নজরে জানতে পারবেন—
              </p>
              <ul className="space-y-2 text-muted-foreground">
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  <span>কোন .BD ডোমেইনের জন্য কী কী ডকুমেন্ট প্রয়োজন</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  <span>কারা আবেদন করতে পারবেন</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1">•</span>
                  <span>কোন ক্ষেত্রে Authorization Letter বাধ্যতামূলক</span>
                </li>
              </ul>
            </div>

            {/* Domain Extensions Section */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-foreground mb-8 flex items-center gap-3">
                <FileText className="w-6 h-6 text-primary" />
                .BD ডোমেইন রেজিস্ট্রেশনের প্রয়োজনীয় ডকুমেন্ট (এক্সটেনশন অনুযায়ী)
              </h2>

              <div className="space-y-6">
                {domainExtensions.map((domain) => (
                  <div
                    key={domain.extension}
                    className="p-6 rounded-xl bg-card border border-border"
                  >
                    <h3 className="text-xl font-bold text-primary mb-4 text-center md:text-left">
                      {domain.extension}
                    </h3>
                    
                    <div className="mb-4">
                      <h4 className="text-sm font-semibold text-foreground mb-2 uppercase tracking-wide">
                        প্রয়োজনীয় ডকুমেন্ট:
                      </h4>
                      <ul className="space-y-2">
                        {domain.documents.map((doc, index) => (
                          <li key={index} className="flex items-start gap-2 text-muted-foreground">
                            <span className="text-green-500 mt-1">✓</span>
                            <span>{doc}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="pt-4 border-t border-border">
                      <h4 className="text-sm font-semibold text-foreground mb-1 uppercase tracking-wide">
                        সাধারণ ব্যবহার:
                      </h4>
                      <p className="text-muted-foreground text-sm">{domain.usage}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Warning Section */}
            <div className="p-8 rounded-2xl bg-orange-50 border border-orange-200 mb-12">
              <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                  <AlertTriangle className="w-6 h-6 text-orange-600" />
                </div>
                <div className="text-center md:text-left">
                  <h3 className="text-xl font-bold text-foreground mb-4">
                    ⚠️ সঠিক ডকুমেন্ট দেওয়া কেন জরুরি?
                  </h3>
                  <p className="text-muted-foreground mb-4">
                    ভুল বা অসম্পূর্ণ ডকুমেন্ট জমা দিলে—
                  </p>
                  <ul className="space-y-2 text-muted-foreground inline-block text-left">
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-1">•</span>
                      <span>ডোমেইন আবেদন রিজেক্ট হতে পারে</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-1">•</span>
                      <span>ভেরিফিকেশন প্রক্রিয়া বিলম্বিত হতে পারে</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-orange-500 mt-1">•</span>
                      <span>ভবিষ্যতে ডোমেইন সাসপেন্ড হওয়ার ঝুঁকি থাকে</span>
                    </li>
                  </ul>
                  <p className="text-muted-foreground mt-4">
                    Web Host Buy BD ও BTCL খুব কঠোরভাবে ডকুমেন্ট যাচাই করে, তাই প্রতিটি এক্সটেনশনের জন্য নির্দিষ্ট কাগজপত্র প্রদান করা বাধ্যতামূলক।
                  </p>
                </div>
              </div>
            </div>

            {/* Support Section */}
            <div className="p-8 rounded-2xl bg-card border border-primary/20">
              <div className="flex flex-col md:flex-row items-center md:items-start gap-4">
                <div className="w-12 h-12 gradient-primary rounded-full flex items-center justify-center flex-shrink-0">
                  <HeadphonesIcon className="w-6 h-6 text-primary-foreground" />
                </div>
                <div className="text-center md:text-left">
                  <h3 className="text-xl font-bold text-foreground mb-4">
                    🤝 Web Host Buy BD থেকে সহায়তা
                  </h3>
                  <p className="text-muted-foreground">
                    আপনি যদি নিশ্চিত না হন—কোন ডোমেইনের জন্য কোন ডকুমেন্ট লাগবে, বা Authorization Letter প্রয়োজন হবে কি না, তাহলে Web Host Buy BD টিম আপনাকে শুরু থেকে অনুমোদন পর্যন্ত সম্পূর্ণ সহযোগিতা দেবে।
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default RequiredDocuments;
